import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { type DependencyState, Status } from '../../../../../../../shared/dependenciesV2';
import * as DependenciesV2Store from '../../../../../../redux/dependenciesV2';
import { getStatusFromDependencyState } from '../helpers';
import type Locator from '../../../../../../../shared/Locator';
import type { DependencyV2Modals } from '../../../hooks/useDependencyModals';

import BuildStatePanel from './BuildStatePanel';
import FailedStatePanel from './FailedStatePanel';
import LoadingPanel from './LoadingPanel';
import UnknownStatePanel from './UnknownStatePanel';

type Props = {
  revision: Locator;
  status: DependencyState;
  modals: DependencyV2Modals
};

const StateContextPanel: VoidFunctionComponent<Props> = ({
  revision,
  status,
  modals,
}) => {
  const revisionInstance = useSelector(DependenciesV2Store.selectors.getBuildWatchRevision(revision.toFullString()));
  const latestBuild = useSelector(DependenciesV2Store.selectors.getLatestBuildOnRevision(revision.toFullString()));
  const statusState = getStatusFromDependencyState(status);

  if (statusState === Status.Analyzed) {
    return null;
  }

  if (!revisionInstance && statusState !== Status.Unknown) {
    return <LoadingPanel />;
  }

  return (
    <>
      {statusState === Status.Failed
        && <FailedStatePanel error={status.error} />}
      {statusState === Status.InProgress
        && <BuildStatePanel buildId={latestBuild?.id} buildModal={modals.streamBuildModal} />}
      {statusState === Status.Unknown && <UnknownStatePanel revision={revision.toFullString()} />}
    </>
  );
};

export default StateContextPanel;
